(function () {
  'use strict';

  const initializeTabNavigation = () => {
    document
      .querySelectorAll('[data-section-product-tabs-id]')
      .forEach((tabsSection) => {
        const tabsNav = tabsSection.querySelector('.tabs-nav');

        if (!tabsNav) return;

        /*
         * Verhindert doppelte Event Listener,
         * falls die Section erneut initialisiert wird.
         */
        if (tabsNav.dataset.tabsInitialized === 'true') return;

        tabsNav.dataset.tabsInitialized = 'true';

        tabsNav.addEventListener('click', (event) => {
          const clickedButton = event.target.closest('.tab-btn');

          if (!clickedButton || !tabsNav.contains(clickedButton)) return;

          /*
           * WICHTIG:
           * Nicht mehr aus data-tab eine ID zusammenbauen.
           * Stattdessen direkt aria-controls verwenden.
           *
           * Beispiel:
           * aria-controls="tab-details-template--123__product_tabs"
           */
          const controlledPanelId =
            clickedButton.getAttribute('aria-controls');

          if (!controlledPanelId) return;

          const activePanel = tabsSection.querySelector(
            `#${CSS.escape(controlledPanelId)}`
          );

          if (!activePanel) {
            console.warn(
              'Produkt-Tab Panel nicht gefunden:',
              controlledPanelId
            );
            return;
          }

          /*
           * Buttons aktualisieren
           */
          tabsSection.querySelectorAll('.tab-btn').forEach((button) => {
            const isActive = button === clickedButton;

            button.classList.toggle('active', isActive);

            button.setAttribute(
              'aria-selected',
              isActive ? 'true' : 'false'
            );

            button.tabIndex = isActive ? 0 : -1;
          });

          /*
           * Panels schließen
           */
          tabsSection.querySelectorAll('.tab-panel').forEach((panel) => {
            panel.classList.remove('active');
            panel.hidden = true;
          });

          /*
           * Gewünschtes Panel öffnen
           */
          activePanel.classList.add('active');
          activePanel.hidden = false;
        });
      });
  };


  const restoreActiveTab = (tabsSection, activeTabName) => {
    if (!tabsSection || !activeTabName) return;

    const activeButton = tabsSection.querySelector(
      `.tab-btn[data-tab="${CSS.escape(activeTabName)}"]`
    );

    if (!activeButton) return;

    /*
     * Auch hier aria-controls benutzen,
     * damit die Shopify Section-ID erhalten bleibt.
     */
    const controlledPanelId =
      activeButton.getAttribute('aria-controls');

    if (!controlledPanelId) return;

    const activePanel = tabsSection.querySelector(
      `#${CSS.escape(controlledPanelId)}`
    );

    if (!activePanel) {
      console.warn(
        'Produkt-Tab Panel konnte nicht wiederhergestellt werden:',
        controlledPanelId
      );
      return;
    }

    tabsSection.querySelectorAll('.tab-btn').forEach((button) => {
      const isActive = button === activeButton;

      button.classList.toggle('active', isActive);

      button.setAttribute(
        'aria-selected',
        isActive ? 'true' : 'false'
      );

      button.tabIndex = isActive ? 0 : -1;
    });

    tabsSection.querySelectorAll('.tab-panel').forEach((panel) => {
      panel.classList.remove('active');
      panel.hidden = true;
    });

    activePanel.classList.add('active');
    activePanel.hidden = false;
  };


  const handleVariantChange = () => {
    const variantSelector = document.querySelector(
      'variant-radios, variant-selects'
    );

    if (!variantSelector) return;

    if (variantSelector.dataset.tabsVariantInitialized === 'true') {
      return;
    }

    variantSelector.dataset.tabsVariantInitialized = 'true';

    variantSelector.addEventListener('change', function () {
      /*
       * Shopify kurz Zeit geben,
       * die aktuelle Variante zu aktualisieren.
       */
      window.setTimeout(() => {
        const url = this.dataset?.url;
        const variantId = this.currentVariant?.id;

        const tabsSection = document.querySelector(
          '[data-section-product-tabs-id]'
        );

        if (!tabsSection || !url || !variantId) return;

        const tabsSectionId =
          tabsSection.dataset.sectionProductTabsId;

        if (!tabsSectionId) return;

        /*
         * Aktuell geöffneten Tab merken.
         */
        const currentlyActiveButton =
          tabsSection.querySelector('.tab-btn.active');

        const activeTabName =
          currentlyActiveButton?.dataset?.tab || 'description';

        const separator = url.includes('?') ? '&' : '?';

        const variantFetchUrl =
          `${url}${separator}variant=${encodeURIComponent(variantId)}` +
          `&section_id=${encodeURIComponent(tabsSectionId)}`;

        fetch(variantFetchUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Produkt-Tabs konnten nicht geladen werden: ${response.status}`
              );
            }

            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const newTabsSection = html.querySelector(
              '[data-section-product-tabs-id]'
            );

            if (!newTabsSection) return;

            /*
             * Nur Inhalt ersetzen.
             */
            tabsSection.innerHTML = newTabsSection.innerHTML;

            /*
             * Neue Navigation initialisieren.
             */
            initializeTabNavigation();

            /*
             * Vorher geöffneten Tab wieder anzeigen.
             */
            restoreActiveTab(
              tabsSection,
              activeTabName
            );
          })
          .catch((error) => {
            console.error(
              'Fehler beim Aktualisieren der Produkt-Tabs:',
              error
            );
          });
      }, 50);
    });
  };


  const initialize = () => {
    initializeTabNavigation();
    handleVariantChange();
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }


  /*
   * Shopify Theme Editor Support
   */
  document.addEventListener(
    'shopify:section:load',
    initializeTabNavigation
  );
})();